import React from 'react';
import PropTypes from 'prop-types';

import Buttons from './Buttons';

import { Box } from '@mui/material';

const FloatingActions = ({onSubmit, onDiscard, onPublish, unsavedChanges}) => {
  
  const primaryAction = unsavedChanges ? onSubmit : onPublish;
  const primaryActionLabel = unsavedChanges ? "Save Changes" : "Publish & Activate Club";
  const secondaryAction = unsavedChanges ? onDiscard : null;
  const secondaryActionLabel = unsavedChanges ? "Discard" : null;

  return (
    <Box
      sx={{
        position: "fixed",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1000,
        backgroundColor: "white",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
        padding: "12px 20px",
        display: "flex",
        gap: 2,
        flexDirection: 'row',
        borderRadius: 3,
        bottom: 20,
        minWidth: 'auto'
      }}
    >

      <Buttons
        primaryAction={primaryAction}
        primaryActionLabel={primaryActionLabel}
        secondaryAction={secondaryAction}
        secondaryActionLabel={secondaryActionLabel}
        noWrap
      />
    </Box>
  );
};

FloatingActions.propTypes = {
  onSubmit: PropTypes.func,
  onDiscard: PropTypes.func,
  onPublish: PropTypes.func,
  unsavedChanges: PropTypes.bool,
};

export default FloatingActions;